import React from "react";
import styled from "styled-components";
import TailSpin from "./Loader";

const Spinner = () => {
  const SpinnerContainer = styled.div`
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  return (
    <SpinnerContainer>
      <TailSpin />
    </SpinnerContainer>
  );
};

export default Spinner;
